/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { Car } from 'src/app/_model/car';

@Injectable()
export abstract class CarsDaoService implements Resetable {
  public abstract saveCars(Cars: Car[]): Promise<void>;
  public abstract getCars(): Promise<Car[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
